export const projects = [
  {
    id: 1,
    title: "UniBrain ERP",
    image: "/images/erp.png",
    description:
      "A multi-company SaaS ERP system for HR, production, sales, and executive reporting with secure role-based access.",
    tech: ["Django", "DRF", "React", "Tailwind"],
    link: "https://unibrainerp-rlp4.onrender.com/",
    group: "ERP System",
    role: "Full System",
  },

  {
    id: 2,
    title: "Dee Makokha Portfolio",
    image: "/images/portfolio.png",
    description:
      "A modern personal portfolio with animations, responsive design, and interactive UI showcasing projects and experience.",
    tech: ["React", "Vite", "Tailwind", "Framer Motion"],
    link: "https://dee-makokha.vercel.app/",
    group: "Personal",
    role: "Frontend",
  },

  {
    id: 3,
    title: "Task Manager API",
    image: "/images/task-api-blog.png",
    description:
      "A Laravel-based REST API with strict business rules, status workflows, and reporting endpoints.",
    tech: ["Laravel", "PHP", "MySQL", "PostgreSQL"],
    link: "https://taskmanagerassignment-production.up.railway.app",
    blog: "/blog/task-manager-api-build",
    group: "Task Management System",
    role: "Backend API",
  },

  {
    id: 4,
    title: "Task Manager Frontend",
    image: "/images/task-frontend-blog.jpg",
    description:
      "A Next.js dashboard with real-time updates, filtering, analytics, and API integration.",
    tech: ["Next.js", "TypeScript", "Tailwind", "Recharts"],
    link: "https://taskassistance.vercel.app",
    blog: "/blog/task-manager-frontend-build",
    group: "Task Management System",
    role: "Frontend Dashboard",
  },

{
  id: 5,
  title: "Holiday Card Generator API",
  image: "/images/holiday_card.png",
  description:
    "A Flask-based image processing API that generates personalized holiday cards using dynamic templates, overlays, and seasonal logic.",
  tech: ["Python", "Flask", "Pillow", "Image Processing"],
  link: "https://https://al-assistant.onrender.com",
  blog: "/blog/holiday-card-backend-build",
  group: "Holiday Card Generator",
  role: "Backend API",
},

{
  id: 6,
  title: "Holiday Card Generator Frontend",
  image: "/images/front_card.png",
  description:
    "A React-based UI for generating and downloading personalized holiday cards with image upload, preview, and sharing features.",
  tech: ["React", "Axios", "CSS"],
  link: "https://holiday-card-gules.vercel.app/",
  blog: "/blog/holiday-card-frontend-build",
  group: "Holiday Card Generator",
  role: "Frontend Interface",
}
];